import Header from './components/Header/Header';
import Carousel from './components/Carousel/Carousel';
import About from './components/About/About';
import Projects from './components/Projects/Projects';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <>
      <Header />
      <Carousel />
      <About />
      <Projects />
      <Footer />
    </>
  );
}

export default App;
